module.exports = __webpack_public_path__ + "static/media/Landing_Illustration.1c202382.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing_Illustration.png
// module id = 2022
// module chunks = 0